var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoColouree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "60mm",
    height: "12mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 6000 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\r\n    .fil0 {fill:#00CCFF}\r\n    .fil1 {fill:gray}\r\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2270100588384"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M4642.73 415.4c212.6,-56.97 431.13,69.2 488.1,281.8l-85.89 49.59 0 0 -195.92 113.11 0 0 -132.84 -76.7 243.56 -140.61c-62.99,-85.35 -173.97,-127.99 -282.63,-98.88 -141.73,37.98 -225.85,183.67 -187.87,325.4 37.98,141.74 183.67,225.85 325.4,187.87 70.87,-18.99 127.33,-64.9 161.33,-123.79l115.05 66.42c-51,88.33 -135.69,157.21 -242,185.69 -212.6,56.97 -431.13,-69.2 -488.1,-281.8 -56.96,-212.61 69.21,-431.14 281.81,-488.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M5506.22 415.39c212.6,-56.96 431.13,69.2 488.1,281.81l-85.89 49.58 0 0.01 -195.92 113.11 0 0 -132.84 -76.7 243.56 -140.61c-63,-85.35 -173.97,-127.99 -282.63,-98.88 -141.74,37.98 -225.85,183.67 -187.87,325.4 37.98,141.74 183.66,225.85 325.4,187.87 70.87,-18.99 127.33,-64.9 161.33,-123.79l115.04 66.42c-50.99,88.33 -135.69,157.21 -241.99,185.69 -212.6,56.97 -431.13,-69.2 -488.1,-281.8 -56.97,-212.61 69.2,-431.14 281.81,-488.11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M1159.09 401.82c220.1,0 398.53,178.43 398.53,398.53 0,220.1 -178.43,398.53 -398.53,398.53 -220.11,0 -398.53,-178.43 -398.53,-398.53 0,-220.1 178.42,-398.53 398.53,-398.53zm0 132.84c146.73,0 265.69,118.95 265.69,265.69 0,146.73 -118.96,265.69 -265.69,265.69 -146.74,0 -265.69,-118.96 -265.69,-265.69 0,-146.74 118.95,-265.69 265.69,-265.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M2354.68 401.82c220.11,0 398.54,178.43 398.54,398.53 0,220.1 -178.43,398.53 -398.54,398.53 -220.1,0 -398.53,-178.43 -398.53,-398.53 0,-220.1 178.43,-398.53 398.53,-398.53zm0 132.84c146.74,0 265.69,118.95 265.69,265.69 0,146.73 -118.95,265.69 -265.69,265.69 -146.73,0 -265.68,-118.96 -265.68,-265.69 0,-146.74 118.95,-265.69 265.68,-265.69z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "1823.31,3.28 1690.46,3.28 1690.46,1198.88 1823.31,1198.88 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M111.07 518.54c155.63,-155.63 407.97,-155.63 563.61,0l-93.94 93.94c-103.76,-103.76 -271.98,-103.76 -375.74,0 -103.75,103.76 -103.75,271.98 0,375.74 103.76,103.76 271.98,103.76 375.74,0l93.94 93.94c-155.64,155.63 -407.98,155.63 -563.61,0 -155.64,-155.64 -155.64,-407.98 0,-563.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M3683.12 800.35l0 -398.53 -132.84 0 0 398.53c0,146.73 -118.95,265.69 -265.69,265.69 -146.73,0 -265.69,-118.96 -265.69,-265.69l0 -398.53 -132.84 0 0 398.53c0,220.1 178.43,398.53 398.53,398.53 220.11,0 398.53,-178.43 398.53,-398.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M4214.5 401.82c52.89,0 103.36,10.32 149.54,29.03 -32.38,33.46 -60.39,71.15 -83.15,112.17 -21.22,-5.45 -43.46,-8.36 -66.39,-8.36 -146.73,0 -265.69,118.95 -265.69,265.69l0 398.53 -132.84 0 0 -398.53c0,-220.1 178.43,-398.53 398.53,-398.53z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColouree);
export default __webpack_public_path__ + "static/media/Logo_Colouree.56ef6c745f39dc2d7c5794b0bc74f123.svg";
export { ForwardRef as ReactComponent };